// Sortable column headers.
//
// Genuinely new in this app - no list has clickable headers today, though
// buildSort in utils/queryFeatures.js has understood `?sort=` since the first
// one. Written generally, but **adopted only on /listen in this PR**:
// retrofitting the four existing lists is a separate change with its own visual
// review, and bundling it here would make the diff unreviewable.
//
// The control is a button *inside* the th rather than a click handler on the
// th itself, which is not focusable and announces nothing to a screen reader.
// `aria-sort` on the th carries the state.

/**
 * Wires sortable headers inside a results region.
 *
 * Delegated from the region rather than bound per header, so the headers that
 * arrive with each refreshed fragment are live without rebinding anything.
 *
 * @param {object} options
 * @param {string} options.results  id of the results region
 * @param {function} options.onSort called with the new sort value, e.g. '-name'
 * @param {function} options.current returns the sort in force, so a second
 *   click on the same column reverses it rather than re-sorting ascending
 * @returns {boolean} false when the region is not on this page
 */
export function initSortHeaders({ results, onSort, current }) {
  const region = document.getElementById(results);
  if (!region || typeof onSort !== 'function') return false;

  region.addEventListener('click', (event) => {
    const button = event.target.closest('[data-sort]');
    if (!button || !region.contains(button)) return;

    const feld = button.dataset.sort;
    const jetzt = typeof current === 'function' ? current() : '';

    // A click on the column already sorted flips the direction; a click on any
    // other column starts ascending, which is what somebody scanning a name
    // column expects.
    const absteigend = jetzt === feld;
    onSort(absteigend ? `-${feld}` : feld);
  });

  return true;
}
